class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this),
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this),
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );

    // CSO-334: when the search modal opens on mobile while the header is sticky, the search bar can
    // open off-screen and the page doesn't scroll to it. Scroll back to the top so it's immediately
    // visible. Scoped to the header search modal + mobile so other modals are unaffected.
    if (this.classList.contains("header__search") && window.innerWidth <= 990) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
    // CSO-334: predictive-search locks <html> on input focus (predictive-search.js onFocus) but only
    // releases it in its own close(), which never runs on mobile (onFocusOut is gated to >990px). The
    // mobile modal closes through here, so release the <html> lock too or the page stays unscrollable.
    document.documentElement.classList.remove("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);
